var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M3.17 20.81a.566.566 0 0 0 .81 0l8.01-8.01L20 20.81c.22.227.588.227.81 0a.565.565 0 0 0 0-.81l-8.01-8.01 8.01-8.01a.565.565 0 0 0 0-.81.565.565 0 0 0-.81 0l-8.01 8.01-8.01-8.01a.566.566 0 0 0-.81 0 .566.566 0 0 0 0 .81l8.01 8.01L3.17 20a.565.565 0 0 0 0 .81"
})));
export default SvgClose;